
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.79 8.04a.76.76 0 000 1.51.74.74 0 00.75-.76.76.76 0 00-.75-.75zM11.79 10.92a.74.74 0 00-.75.75v3.12a.75.75 0 001.5 0v-3.1a.75.75 0 00-.75-.77z"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M11.79 2C6.385 2.006 2.006 6.385 2 11.79c0 5.407 4.383 9.79 9.79 9.79 5.407 0 9.79-4.383 9.79-9.79-.005-5.405-4.385-9.784-9.79-9.79zm0 18.08a8.29 8.29 0 118.29-8.29 8.3 8.3 0 01-8.29 8.29z"}})])
          )
        }
      }
    